export const TABLE_DATA = {
  heading: "Managed vs. Unmanaged vs. Co-managed Services",
  columns: ["Managed Services", "Unmanaged Services", "Co-managed Services"],
  data: [
    {
      feature: "Infrastructure Management",
      "Managed Services": "Fully handled by MSP",
      "Unmanaged Services": "Managed internally",
      "Co-managed Services": "Shared between MSP & IT team",
    },
    {
      feature: "Security & Compliance",
      "Managed Services": "24/7 monitoring, firewalls, & compliance adherence",
      "Unmanaged Services": "Self-managed security policies",
      "Co-managed Services": "MSP assists in security implementation",
    },
    {
      feature: "Technical Support",
      "Managed Services": "24/7 proactive support",
      "Unmanaged Services": "No external support",
      "Co-managed Services": "MSP provides on-demand support",
    },
    {
      feature: "Software Updates & Patching",
      "Managed Services": "Automatic updates & patching",
      "Unmanaged Services": "Requires manual updates",
      "Co-managed Services": "MSP supports IT team with updates",
    },
    {
      feature: "Cost",
      "Managed Services": "Subscription-based pricing",
      "Unmanaged Services": "Lower initial cost, but higher long-term maintenance cost",
      "Co-managed Services": "Flexible pricing based on services used",
    },
    {
      feature: "Customization & Control",
      "Managed Services": "Limited customization, as MSP manages operations",
      "Unmanaged Services": "Full control over infrastructure & configurations",
      "Co-managed Services": "Flexible—businesses retain control over key IT operations",
    },
  ],
};
